import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'globot-ready-step',
  template: `
    <div class="grid layout mt-8">
      <div class="col-12 flex align-items-center justify-content-center" style="text-align:center">
        <span
          [style.backgroundColor]="'#BBF7D0'"
          class="flex z-1 w-4rem h-4rem align-items-center justify-content-center text-white border-circle shadow-2"
        >
          <i [ngClass]="'pi pi-check'" style="color: #16A34A;font-size:18px"></i>
        </span>
      </div>
      <div class="col-12">
        <h1 style="text-align: center;  font-weight: 700; font-family: sans-serif;">¡Listo!</h1>
        <p style="text-align: center;">Ya puedes probar tu chatbot</p>
      </div>
      <div
        class="col-12 md:col-4 lg:col-4 flex align-items-center justify-content-center bottom-button"
      >
        <p-button
          [style]="{ width: '124px', height: '48px' }"
          [routerLink]="'/dashboard/edit-bot/' + id + '/widget-config'"
          icon="pi pi-arrow-right"
          iconPos="right"
          label="Empezar"
        ></p-button>
      </div>
    </div>
  `,
  styleUrls: ['./ready-step.component.scss'],
})
export class ReadyStepComponent {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();
  @Output() botNameEvent = new EventEmitter<string>();

  @Input() id: string = '';

  botName: string = '';

  constructor() {
    //Auto generated name bot initial value bot
    this.botName = `ScapeGpt-${Math.floor(Math.random() * 1000)}`;
    this.botNameEvent.emit(this.botName);
  }

  next(): void {
    this.nextEvent.emit();
  }

  back(): void {
    this.backEvent.emit();
  }
}
